module.exports = __webpack_public_path__ + "img/azure.eb8fe01e.svg";